import React from 'react';
import { Tag } from 'antd';

interface Props {
  label: string;
  backgroundColor?: string;
  color?: string;
  style?: React.CSSProperties;
}

/**
 * Tag de statut appliquant une couleur de fond/texte donnée, avec un
 * fallback sur le style par défaut d'AntD lorsqu'aucune couleur n'est
 * définie pour le statut (utilisé notamment dans `SuiviLeads.tab.tsx`).
 */
const ColoredStatusTag: React.FC<Props> = ({
  label,
  backgroundColor,
  color,
  style,
}) => {
  if (!backgroundColor || !color) {
    return <Tag style={style}>{label}</Tag>;
  }

  return (
    <Tag
      style={{
        backgroundColor,
        color,
        border: 'none',
        borderRadius: 4,
        ...style,
      }}
    >
      {label}
    </Tag>
  );
};

export default ColoredStatusTag;
